import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import MobileNumberInput from "./pages/MobileNumberInput";
import UserLandingPage from "./pages/UserLandingPage";
import TransactionsPage from "./pages/TransactionsPage";
import VoucherList from "./pages/VoucherList";
import AdminDashboard from "./pages/AdminDashboard";
import AdminLoginPage from "./pages/AdminLoginPage";
import UserLoginPage from "./pages/UserLoginPage";
import AddColorPage from "./components/AddColorPage"; 
import ReportsPage from "./components/ReportsPage";

const SecureRoute = ({ element }) => {
  const token = localStorage.getItem("token");
  if (!token) {
    return <Navigate to="/" />;
  }
  return element;
};

function App() {
  return (
    <Router>
      <Routes>
        {/* 🔐 User Routes */}
        <Route path="/" element={<UserLoginPage />} />
        <Route path="/user/:hash" element={<SecureRoute element={<UserLandingPage />} />} />
        <Route path="/user/:hash/transactions" element={<SecureRoute element={<TransactionsPage />} />} />
        <Route path="/user/:hash/vouchers" element={<SecureRoute element={<VoucherList />} />} />

        {/* 🔐 Admin Routes */}
        {/* Main Dashboard */}
        <Route path="/a/:hash" element={<SecureRoute element={<AdminDashboard />} />} />
        
        {/* Reports Page */}
        <Route path="/a/:hash/reports" element={<SecureRoute element={<ReportsPage />} />} />
        
        {/* Colors Page */}
        <Route path="/a/:hash/colors" element={<SecureRoute element={<AddColorPage />} />} />

        {/* Other Routes */}
        <Route path="/User" element={<UserLoginPage />} />
        <Route path="/admin" element={<AdminLoginPage />} /> {/* Fixed this to AdminLoginPage */}
      </Routes>
    </Router>
  );
}

export default App;